import { toast } from "sonner";

import { downloadCsv } from "@/utils/common.utils";
import type { OverviewExportRow } from "@/types/overview.types";

/**
 * Build the dashboard CSV from server-supplied rows.
 *
 * The rows arrive from `GET /overview/export`, which applies the page's date
 * range server-side and returns the whole matching set. The previous version
 * built this from whatever deals were already in memory, so the file silently
 * reflected the page you happened to be looking at rather than the filter you
 * had applied.
 */
export function exportOverviewReport(rows: OverviewExportRow[]): void {
  if (!rows.length) {
    toast.info("There are no deals to export");
    return;
  }
  downloadCsv({
    filename: "deals-report.csv",
    rows: [
      ["Address", "Client side", "Stage", "Health", "Agent", "List price", "Contract price", "Closing date", "Created", "Updated"],
      ...rows.map((row) => [
        row.address,
        row.deal_type,
        row.phase_label,
        row.deal_health === "on_track" ? "On track" : "Needs attention",
        row.agent_name,
        row.list_price ?? "",
        row.contract_price ?? "",
        row.closing_date ?? "",
        row.created_at,
        row.updated_at,
      ]),
    ],
  });
}
